import { inject, Component, Inject, TemplateRef, ViewChild, Input, OnChanges, SimpleChanges, AfterViewInit, QueryList, signal, computed , PipeTransform} from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataGridView, DataGridViewCollumn, Types } from "../../../Componente/DataGridView";
import { PopUpView } from "../../../Componente/PopUpView";
import { Geraete } from "../../../Api/DcoApi/Admin/AdminClasses2";
import { FloatingButtonComponent } from "../../../Componente/floatingButton";
import { RestClient, User } from "../../../Api/DcoApi/Client/RestClient";
import { ToastService } from "../../../Akte/Services/Toasts/ToastService";
import { StatusModel } from "../../../Api/DcoApi/Status/StatusModel";
import { PGFilterService } from "../../Services/PGFilterService";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap/modal";
import { AktePopup } from "./AktePopup";
import { DateSelect } from "../../../Akte/Controlls/DateSelect";
import { StatusPipe } from "../../../Pipes/StatusPipe";



@Component({
  imports: [
    CommonModule,
    FormsModule,
    DataGridView,
    DataGridViewCollumn,
    PopUpView, FloatingButtonComponent, DateSelect, FloatingButtonComponent
  ],
  selector: 'VNRStatus',
  templateUrl: './VNRStatus.html',
  standalone: true,
  styleUrl: './VNRStatus.css'
})
export class VNRStatus implements OnChanges, AfterViewInit {
  @ViewChild('Grid') childComponent!: DataGridView<StatusModel>;
  @Input() versichertenNr?: string | null = null;
  toastService: ToastService;

  private modalService = inject(NgbModal);
  modal = inject(NgbActiveModal);

  dataurl = computed(() => { return `/Backend/Api/V2/Status/Versicherter/${this.versichertenNr}/List` })
  constructor(public pgService: PGFilterService) {
    this.toastService = inject(ToastService)

  }
  ngAfterViewInit(): void {
    this.loadColumns();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["Status"]) {
      this.loadColumns();
    }
  }

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }

  loadColumns() {
    var columns = [{ field: 'key', DataType: Types.Number, isKey: true, header: 'ID', cellClass: (data: StatusModel, field: any) => { return ""; }, AllowOrder: true, AllowSearch: true } as DataGridViewCollumn<StatusModel>]


    var buttonTemplate = this.buttonTemplate;

    this.pushStandardUserColumns(columns);



    columns.push(new DataGridViewCollumn<StatusModel>().setValues({ field: 'key', header: '', cellTemplate: buttonTemplate, isFixed: true, cellClass: (data: StatusModel, field: any) => { return ""; } } as DataGridViewCollumn<StatusModel>))
    if (this.childComponent) {
      this.childComponent.columns.reset(columns);
      this.childComponent.columns.notifyOnChanges();
    }
  }

  OpenAkte(row: StatusModel) {
    var modal = this.modalService.open(AktePopup)
    modal.componentInstance.Key = row.key;
    modal.componentInstance.versichertenNr = row.versicherungsId;
    modal.closed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
    modal.dismissed.subscribe({
      next: async (config) => {
        this.triggerReload();
      },
      error: (err) => {
        this.triggerReload();
      },
    });
  }

  pushStandardUserColumns(columns: DataGridViewCollumn<StatusModel>[], includeKrankenkasse: boolean = false) {
    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'userFirstName', header: 'Kunde Vorname',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
    } as DataGridViewCollumn<StatusModel>));

    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'userLastName', header: 'Kunde Nachname',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
    } as DataGridViewCollumn<StatusModel>));

    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'versicherungsId', header: 'Versichertennummer',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
    } as DataGridViewCollumn<StatusModel>));
    if (includeKrankenkasse) {

      columns.push(new DataGridViewCollumn<StatusModel>().setValues({
        field: 'krankenkasseName', header: 'Krankenkasse',
        cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
      } as DataGridViewCollumn<StatusModel>));
    }

    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'kooperationspartnerName', header: 'Kooperationspartner',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.String
    } as DataGridViewCollumn<StatusModel>));
    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'createdAt', header: 'AntragVon',
      cellClass: (data: StatusModel, field: any) => '', AllowOrder: true, AllowSearch: true, DataType: Types.Date
    } as DataGridViewCollumn<StatusModel>));

    columns.push(new DataGridViewCollumn<StatusModel>().setValues({
      field: 'status', header: 'Status',
      cellClass: (data: StatusModel, field: any) => this.statusClass(data.status), AllowOrder: true, AllowSearch: true, DataType: Types.String, pipe: StatusPipe
    } as DataGridViewCollumn<StatusModel>));
  }

  @ViewChild('buttonTemplate') buttonTemplate!: TemplateRef<any>;


  Client: RestClient = new RestClient();

  statusClass(status: number): string {

    switch (status) {
      case 20:
      case 21:
      case 26:
      case 30:
      case 31:
      case 40:
      case 42:
      case 51:
        return "SYelow";
      case 55:
        return 'SOrange';
      case 200:
        return 'SGreen';
      case 800:
      case 801:
      case 802:
      case 803:
      case 804:
      case 805:
      case 806:
      case 807:
      case 808:
      case 809:
      case 810:
        return 'SBloue';
      case -26:
        return 'SLBloue';
      case 900:
      case 901:
      case 902:
        return 'SRed';
    }

    return '';
  }


}
